import { ControlledTextField } from '@/components/validated-text-field';
import { useGenders } from '@/hooks/use-genders';
import { AccountGender } from '@calm/evexia-web-sdk';
import { MenuItem, SxProps, Theme } from '@rhg/libs/material';
import { Control } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { ageGenderMessages } from '../messages';

interface GenderSelectProps {
    control: Control<any>;
    onOpen?: () => void;
    onChange?: (gender: AccountGender) => void;
    sx?: SxProps<Theme>;
}

export const GenderSelect = ({
    control,
    onChange,
    onOpen,
    sx,
}: GenderSelectProps) => {
    const { formatMessage } = useIntl();
    const { genders } = useGenders();

    return (
        <ControlledTextField
            label={formatMessage(ageGenderMessages.genderSelectLabel)}
            name="gender"
            control={control}
            textFieldProps={{
                fullWidth: true,
                variant: 'filled',
                sx,
                select: true,
                SelectProps: {
                    onOpen: () => onOpen?.(),
                },
                onChange: (...event) => {
                    onChange?.(event[0].target.value as AccountGender);
                },
            }}
        >
            {Object.values(genders).map(({ key, displayName }) => (
                <MenuItem key={key} value={key} trackButton="NotMapped">
                    {displayName}
                </MenuItem>
            ))}
        </ControlledTextField>
    );
};
